// extracted by mini-css-extract-plugin
module.exports = {"customizations":"ProductDetails_customizations__8_01v","saasCustomizations":"ProductDetails_saasCustomizations__1eClU"};